/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import Skeleton from '@material-ui/lab/Skeleton';
import {
  getAlgoListDataCachedSelectedDay,
  getPageLoading,
} from '../../../../stores/algos-list/getters';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles(() => ({
  root: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    textDecoration: 'underline',
    color: 'var(--color-colorPrimary-main)',
  },
  skeleton: {
    '&.MuiSkeleton-root': {
      backgroundColor: 'var(--color-backgroundColors-disabled)',
    },
  },
}));

const CellName = ({ row = {} }) => {
  const history = useHistory();
  const classes = useStyles();
  const { original = {} } = row;
  const { _id = '' } = original;

  const name = useSelector((state) => {
    const { name = '' } =
      getAlgoListDataCachedSelectedDay(state).find((d) => d._id === _id) || {};

    return name;
  });

  const pageLoading = useSelector(getPageLoading);

  const handleRedirectToAlgoEdit = () => {
    history.push(`/algos/${_id}`, {
      from: window.location.hash,
    });
  };

  return (
    <div className={classes.root} onClick={handleRedirectToAlgoEdit}>
      {pageLoading ? (
        <Skeleton
          variant="rect"
          width={210}
          height={15}
          className={classes.skeleton}
        />
      ) : (
        name
      )}
    </div>
  );
};

export default CellName;
